import { LoadingController, Platform } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { PrescricaoService } from '../../../services/prescricao.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-prescricoes-med-component',
  templateUrl: './prescricoes-med-component.html',
  styleUrls: ['./prescricoes-med-component.scss'],
})
export class PrescricoesMedComponent implements OnInit {

  isMobile = false;
  medicamento: any;
  @Input() id: number;
  @Input() idPrescricao: number;
  @Output() medVoltar = new EventEmitter();

  constructor(
    private active: ActivatedRoute,
    public router: Router,
    private plt: Platform,
    private loadingCtrl: LoadingController,
    private prescricaoService: PrescricaoService
  ) {
    if (this.plt.is('ios') || this.plt.is('android') || this.plt.is('cordova')) {
      this.isMobile = true;
    }
  }

  async ngOnInit() {
    const loading = await this.loadingCtrl.create({
      cssClass: 'superapp-loader',
      spinner: 'crescent'
    });
    await loading.present();
    const detalhePrescricao = await this.prescricaoService.getDetalhe(this.idPrescricao);
    this.medicamento = detalhePrescricao.medicamentos.find(m => m.id == this.id);
    await loading.dismiss();
  }

  voltar() {
    this.medVoltar.emit(this.idPrescricao)
  }
}
